import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersListLayer from "../components/UsersListLayer";

const UsersList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Users List" tooltipContent="New User Data" linkTo="/users/add"  requiredPermission={{ module: 'users', action: 'create' }}  />
    
        {/* TableDataLayer */}
        <UsersListLayer  />

      </MasterLayout>

    </>
  );
};

export default UsersList; 
